import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Col, Row, Button } from '_zari/core'

import { DownloadAxiosFile } from 'utils'

import * as AsientoContableService from 'services/asientosContables.service'

import * as FormGroups from './formGroups'

const portletBreadcrumbs = [{ name: 'Validaciones' }]

const MainForm = () => {
  const __zariContext = React.useContext(ZariContext)

  const [origenDescuadrado, setOrigenDescuadrado] = React.useState('')

  const clickVerificarAsientosDeComprasVentas = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteVerificacionAsientosComprasVentas()
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  const clickDescargarReporteCuadreCuentas206090 = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteCuadreCuentas206090()
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  const clickDescargarReporteCuadreCuentas60Digitadas = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteCuadreCuentas60Digitadas()
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  const clickDescargarReporteCuadreCuentas90Digitadas = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteCuadreCuentas90Digitadas()
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  const clickDescargarReporteAsientosDescuadrados = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteAsientosDescuadrados({ origenDescuadrado: origenDescuadrado })
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext, origenDescuadrado])

  const clickDescargarReporteAsientosSinCC = React.useCallback(() => {
    __zariContext.loader.open('Descargando reporte')
    AsientoContableService.descargarReporteAsientosSinCC()
      .then(({ data, headers }) => {
        __zariContext.snack('success', 'Reporte descargado.')
        DownloadAxiosFile.downloadAsBlob(data, headers)
      })
      .catch(({ data: { error } }) => __zariContext.snack('error', error))
      .finally(() => {
        __zariContext.loader.close()
      })
  }, [__zariContext])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Validaciones' breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Row>
            <Col md={6}>
              <Row className='mt-2'>
                <Col md={12}>
                  <Button onClick={() => clickVerificarAsientosDeComprasVentas()}>
                    Verificar Asientos de Compras / Ventas
                  </Button>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col md={12}>
                  <Button onClick={() => clickDescargarReporteCuadreCuentas206090()}>Cuadre cuentas 206090</Button>
                </Col>
              </Row>
            </Col>
            <Col md={6}>
              <Row>
                <Col md={12}>
                  <Button onClick={() => clickDescargarReporteCuadreCuentas60Digitadas()}>
                    Cuadre cuentas 60 digitadas
                  </Button>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col md={12}>
                  <Button onClick={() => clickDescargarReporteCuadreCuentas90Digitadas()}>
                    Cuadre cuentas 90 digitadas
                  </Button>
                </Col>
              </Row>
              <Row className='mt-2'>
                <Col md={6}>
                  <Button onClick={() => clickDescargarReporteAsientosDescuadrados()}>Asientos Descuadrados</Button>
                </Col>
                <Col xs={6}>
                  <FormGroups.OrigenFormGroup
                    value={origenDescuadrado}
                    onChange={e => {
                      setOrigenDescuadrado(e.target.value)
                    }}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={6}>
                  <Button onClick={() => clickDescargarReporteAsientosSinCC()}>Asientos Sin C.C.</Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Portlet.Body>
      </Portlet>
    </>
  )
}

export default React.memo(MainForm)
